import Env from '../../base/env'

export default class Popin
{
    constructor(view)
    {
        this.view = view
        this.$items = this.view.querySelectorAll('.jsItem')
        // Popin
        this.$popin = Env.$popinView
        this.$popinReceptor = this.$popin.querySelector('.jsReceptor')
        this.$popinClose = this.$popin.querySelector('.jsClose')
        // Objects
        this.timeoutPopinClean = false
        // Flags
        this.POPIN_ENABLED = false
    }

    destroy()
    {
        this.popinClose()
    }

    events()
    {
        for(let i = 0; i < this.$items.length; i++) {
            const $item = this.$items[i]
            $item.addEventListener('click',()=>{
                if(this.POPIN_ENABLED == false) {
                    setTimeout(() => {
                        this.popinOpen($item)
                    }, 200);
                }
                return false
            })
        }

        this.$popinClose.addEventListener('click',()=>{
            if(this.POPIN_ENABLED == true) {
                this.popinClose()
            }
        })
    }

    popinClose()
    {

        this.$popin.classList.remove('is--active')
        Env.$html.classList.remove('popin--isOpened')
        this.POPIN_ENABLED = false

        this.timeoutPopinClean = setTimeout(() => {
            this.$popinReceptor.innerHTML = ''
        }, 500);
    }

    popinOpen($item)
    {
        clearTimeout(this.timeoutPopinClean)
        const html = $item.querySelector('.jsContent').innerHTML
        this.$popinReceptor.innerHTML = html

        this.$popin.classList.add('is--active')
        Env.$html.classList.add('popin--isOpened')
        this.POPIN_ENABLED = true
    }

    setup()
    {
        this.events()
    }
}


// WEBPACK FOOTER //
// ./resources/js/components/crew/Popin.js